import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useCelebrityByScore } from '../../hooks';
import { getCurrentField, getCurrentCountry } from '../../reducers';
import CelebrityCard from './CelebrityCard';

const YEARS = [2019, 2020, 2025];

export default function AnnualRanking() {
  const field = useSelector(getCurrentField);
  const country = useSelector(getCurrentCountry);
  const [year, setYear] = useState(YEARS[YEARS.length - 1]);
  const { t } = useTranslation();
  const {
    celebrities,
    isFetching,
    error,
    more,
    endOfResult,
    orderBy,
  } = useCelebrityByScore(field, year, country);

  function handleYearChange(event) {
    setYear(event.target.value);
  }

  function renderCelebrities(celebrities) {
    return celebrities.map((celebrity, idx) => (
      <CelebrityCard
        key={celebrity.id}
        index={idx}
        celebrity={celebrity}
        text={t('ratings.scoreLabel', {
          value: Math.round(celebrity[orderBy] * 100) / 100,
        })}
      />
    ));
  }

  return (
    <>
      <div className="row">
        <div className="col">
          <h3 style={{ color: '#0A2342' }}>{t('ratings.annualRankings')}</h3>
        </div>
        <div className="col-auto d-flex justify-content-end">
          <form className="form-inline">
            <select
              className="form-control ml-2 custom-select"
              name="year"
              onChange={handleYearChange}
              value={year}
            >
              {YEARS.map(year => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </form>
        </div>
      </div>
      {!isFetching && !celebrities.length ? (
        <div className="row">
          <div className="col-12 mb-2 text-center">
            <span className="text-primary">
              {t('ratings.emptyState')}
            </span>
          </div>
        </div>
      ) : (
        renderCelebrities(celebrities)
      )}
      {!isFetching && error && (
        <div className="row">
          <div className="col-12 mb-2 text-center">
            <span className="text-danger">{error.message}</span>
          </div>
        </div>
      )}
      {!!celebrities.length && endOfResult && (
        <div className="row">
          <div className="col-12 mb-2 text-center">
            <span className="text-primary">{t('ratings.noMoreCelebrities')}</span>
          </div>
        </div>
      )}
      {!endOfResult && (
        <div className="row">
          <div className="col-12 mb-2 text-center">
            <button
              className="btn btn-primary"
              type="button"
              onClick={more}
              onMouseEnter={(e) => { e.target.style.color = '#FFFFFF'; }}
              onMouseLeave={(e) => { e.target.style.color = '#F5F5D1'; }}
              style={{ color: '#F5F5D1' }}
            >
              {isFetching ? (
                <>
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: '#F5F5D1' }}
                  ></span>
                  <span className="sr-only">{t('common.loading')}</span>
                </>
              ) : (
                t('ratings.moreButton')
              )}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
